/* Swissöra premium — interactive PDP tools (V2 brief #9).
   1) Mini-quiz "Quel sérum pour vous ?" → personalised cure recommendation.
   2) Results-timeline simulator (week 1 → 3 → 6) with metric + visual morph.
   Bilingual: reads <html data-lang>. On-brand, genuinely interactive. */
(function () {
  'use strict';

  function lang() { return document.documentElement.getAttribute('data-lang') === 'en' ? 'en' : 'fr'; }
  var L = lang();

  /* ───────────────────────── QUIZ ─────────────────────────
     Two variants: 'cils' (SwissLash, default) + 'sourcils' (SwissBrow).
     Set <div id="quiz" data-variant="sourcils" data-product-url="../products/swissbrow.html">.
     On a PDP (where #bundle exists) the result CTA drives the local buy-box;
     inside an article (no #bundle) it becomes a link to the product page. */
  var QUIZ = {
    cils: {
    fr: {
      steps: [
        { q: 'Vos cils aujourd\'hui ?', a: [
          { t: 'Fins et clairsemés', v: 'long' },
          { t: 'Courts mais fournis', v: 'long' },
          { t: 'Abîmés par les extensions', v: 'repair' }
        ]},
        { q: 'Votre objectif principal ?', a: [
          { t: 'Plus de longueur', v: 'full' },
          { t: 'Plus de densité', v: 'full' },
          { t: 'Renforcer et réparer', v: 'repair' }
        ]},
        { q: 'Votre horizon ?', a: [
          { t: 'Tester (1 mois)', v: '1' },
          { t: 'Une vraie cure (2-3 mois)', v: '2' },
          { t: 'Un résultat durable', v: 'sub' }
        ]}
      ],
      resultTitle: 'Notre recommandation',
      restart: 'Refaire le diagnostic',
      results: {
        '1':  { name: 'Cure découverte — 1 flacon', why: 'Idéale pour une première expérience sur 6 à 8 semaines.', price: '39.99', label: 'Choisir 1 flacon' },
        '2':  { name: 'Cure complète — 2 flacons', why: 'L\'option la plus choisie : menez la cure à son terme sans interruption.', price: '59.99', label: 'Choisir 2 flacons' },
        'sub':{ name: 'Cure longue durée — 3 flacons', why: 'Pour garder le résultat dans le temps. Le tarif le plus avantageux.', price: '74.99', label: 'Choisir 3 flacons' }
      }
    },
    en: {
      steps: [
        { q: 'Your lashes today?', a: [
          { t: 'Fine and sparse', v: 'long' },
          { t: 'Short but full', v: 'long' },
          { t: 'Damaged by extensions', v: 'repair' }
        ]},
        { q: 'Your main goal?', a: [
          { t: 'More length', v: 'full' },
          { t: 'More density', v: 'full' },
          { t: 'Strengthen and repair', v: 'repair' }
        ]},
        { q: 'Your horizon?', a: [
          { t: 'Try it (1 month)', v: '1' },
          { t: 'A real course (2-3 months)', v: '2' },
          { t: 'A lasting result', v: 'sub' }
        ]}
      ],
      resultTitle: 'Our recommendation',
      restart: 'Retake the quiz',
      results: {
        '1':  { name: 'Discovery course — 1 bottle', why: 'Ideal for a first experience over 6 to 8 weeks.', price: '39.99', label: 'Choose 1 bottle' },
        '2':  { name: 'Full course — 2 bottles', why: 'The most chosen option: see the course through without interruption.', price: '59.99', label: 'Choose 2 bottles' },
        'sub':{ name: 'Long course — 3 bottles', why: 'To keep the result over time. The best value.', price: '74.99', label: 'Choose 3 bottles' }
      }
    }
    },
    sourcils: {
    fr: {
      steps: [
        { q: 'Vos sourcils aujourd\'hui ?', a: [
          { t: 'Clairsemés ou irréguliers', v: 'long' },
          { t: 'Fins par endroits', v: 'long' },
          { t: 'Abîmés par l\'épilation', v: 'repair' }
        ]},
        { q: 'Votre objectif principal ?', a: [
          { t: 'Plus de densité', v: 'full' },
          { t: 'Redéfinir la forme', v: 'full' },
          { t: 'Renforcer et réparer', v: 'repair' }
        ]},
        { q: 'Votre horizon ?', a: [
          { t: 'Tester (1 mois)', v: '1' },
          { t: 'Une vraie cure (2-3 mois)', v: '2' },
          { t: 'Un résultat durable', v: 'sub' }
        ]}
      ],
      resultTitle: 'Notre recommandation',
      restart: 'Refaire le diagnostic',
      results: {
        '1':  { name: 'SwissBrow — 1 flacon', why: 'Idéal pour une première cure de 6 à 8 semaines sur vos sourcils.', price: '39.99', label: 'Découvrir SwissBrow' },
        '2':  { name: 'SwissBrow — cure complète', why: 'Menez la cure à son terme sans interruption pour des sourcils visiblement redéfinis.', price: '39.99', label: 'Découvrir SwissBrow' },
        'sub':{ name: 'SwissBrow — résultat durable', why: 'Un usage régulier pour entretenir densité et définition dans le temps.', price: '39.99', label: 'Découvrir SwissBrow' }
      }
    },
    en: {
      steps: [
        { q: 'Your brows today?', a: [
          { t: 'Sparse or uneven', v: 'long' },
          { t: 'Thin in places', v: 'long' },
          { t: 'Damaged by plucking', v: 'repair' }
        ]},
        { q: 'Your main goal?', a: [
          { t: 'More density', v: 'full' },
          { t: 'Redefine the shape', v: 'full' },
          { t: 'Strengthen and repair', v: 'repair' }
        ]},
        { q: 'Your horizon?', a: [
          { t: 'Try it (1 month)', v: '1' },
          { t: 'A real course (2-3 months)', v: '2' },
          { t: 'A lasting result', v: 'sub' }
        ]}
      ],
      resultTitle: 'Our recommendation',
      restart: 'Retake the quiz',
      results: {
        '1':  { name: 'SwissBrow — 1 bottle', why: 'Ideal for a first 6-to-8-week course on your brows.', price: '39.99', label: 'Discover SwissBrow' },
        '2':  { name: 'SwissBrow — full course', why: 'See the course through for visibly redefined brows.', price: '39.99', label: 'Discover SwissBrow' },
        'sub':{ name: 'SwissBrow — lasting result', why: 'Regular use to maintain density and definition over time.', price: '39.99', label: 'Discover SwissBrow' }
      }
    }
    }
  };

  var quizEl = document.getElementById('quiz');
  if (quizEl) {
    var VARIANT = quizEl.getAttribute('data-variant') || 'cils';
    var PDP_URL = quizEl.getAttribute('data-product-url');   /* set on article pages */
    var ON_PDP = !!document.getElementById('bundle');         /* buy-box present = product page */
    var data = (QUIZ[VARIANT] || QUIZ.cils)[L];
    var stage = document.getElementById('quizStage');
    var bar = document.getElementById('quizBar');
    var answers = [];
    var idx = 0;
    var QUIZ_ICONS = [
      ['<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3.5 16c4-1.4 13-1.4 17 0"/><path d="M7 13.5l-1-2.5M12 13l0-3.5M17 13.5l1-2.5"/></svg>',
       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3.5 16c4-1.4 13-1.4 17 0"/><path d="M6 13.5l-.6-2M9 13l-.4-2.4M12 12.8V10.2M15 13l.4-2.4M18 13.5l.6-2"/></svg>',
       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3.5 16c4-1.4 13-1.4 17 0"/><path d="M8 13l-1-2.5M16 13l1-2.5"/><path d="M11 8.5l2 2-2 2 2 2"/></svg>'],
      ['<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V5"/><path d="M7 10l5-5 5 5"/></svg>',
       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4l8 4-8 4-8-4z"/><path d="M4 12l8 4 8-4M4 16l8 4 8-4"/></svg>',
       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>'],
      ['<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M11 8.5h1.6V16"/></svg>',
       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="5.5" width="16" height="14.5" rx="2"/><path d="M4 10h16M8.5 3v4M15.5 3v4"/></svg>',
       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9a8 8 0 0 1 13.5-3.5L20 8"/><path d="M20 15a8 8 0 0 1-13.5 3.5L4 16"/><path d="M20 4v4h-4M4 20v-4h4"/></svg>']
    ];

    function setBar() { bar.style.width = Math.round((idx / data.steps.length) * 100) + '%'; }

    function renderStep() {
      setBar();
      var step = data.steps[idx];
      stage.innerHTML = '<p class="quiz__q">' + step.q + '</p>' +
        '<div class="quiz__opts">' + step.a.map(function (o, i) {
          return '<button type="button" class="quiz__opt" data-v="' + o.v + '" data-i="' + i + '"><span class="quiz__opt-ic">' + ((QUIZ_ICONS[idx]&&QUIZ_ICONS[idx][i])||'') + '</span><span class="quiz__opt-t">' + o.t + '</span></button>';
        }).join('') + '</div>';
      stage.querySelectorAll('.quiz__opt').forEach(function (b) {
        b.addEventListener('click', function () {
          answers.push(b.getAttribute('data-v'));
          idx++;
          if (window.posthog) try { posthog.capture('quiz_answer', { step: idx, value: b.getAttribute('data-v') }); } catch (x) {}
          if (idx >= data.steps.length) renderResult();
          else renderStep();
        });
      });
    }

    function decide() {
      /* horizon answer (last) drives the cure; repair/long bias 1 vs 2 */
      var horizon = answers[2];
      if (horizon === 'sub') return 'sub';
      if (horizon === '1') return '1';
      return '2';
    }

    function renderResult() {
      bar.style.width = '100%';
      var key = decide();
      var r = data.results[key];
      if (window.posthog) try { posthog.capture('quiz_complete', { reco: key, variant: VARIANT }); } catch (x) {}
      /* CTA: on a PDP → drives the local buy-box; in an article → links to the product page. */
      var ctaHTML = (ON_PDP || !PDP_URL)
        ? '<button type="button" class="quiz__result-cta btn3d" id="quizApply">' + r.label + '</button>'
        : '<a class="quiz__result-cta btn3d" id="quizApply" href="' + PDP_URL + '?cure=' + key + '">' + r.label + '</a>';
      stage.innerHTML =
        '<div class="quiz__result">' +
          '<p class="quiz__result-eyebrow">' + data.resultTitle + '</p>' +
          '<h4 class="quiz__result-name">' + r.name + '</h4>' +
          '<p class="quiz__result-why">' + r.why + '</p>' +
          ctaHTML +
          '<button type="button" class="quiz__restart" id="quizRestart">' + data.restart + '</button>' +
        '</div>';
      document.getElementById('quizRestart').addEventListener('click', function () {
        answers = []; idx = 0; renderStep();
      });
      if (ON_PDP || !PDP_URL) {
        document.getElementById('quizApply').addEventListener('click', function () {
          applyReco(key, r);
        });
      } else if (window.posthog) {
        document.getElementById('quizApply').addEventListener('click', function () {
          try { posthog.capture('quiz_to_pdp', { reco: key, variant: VARIANT }); } catch (x) {}
        });
      }
    }

    function applyReco(key, r) {
      var bundle = document.getElementById('bundle');
      var buymode = document.getElementById('buymode');
      if (r.sub && buymode) {
        var subBtn = buymode.querySelector('[data-mode="sub"]');
        if (subBtn) subBtn.click();
      } else if (buymode) {
        var onceBtn = buymode.querySelector('[data-mode="once"]');
        if (onceBtn) onceBtn.click();
      }
      if (bundle && !r.sub) {
        var opts = bundle.querySelectorAll('.bundle__opt');
        var target = key === '1' ? opts[0] : (key === '2' ? opts[1] : opts[1]);
        if (target) target.click();
      }
      var anchor = document.querySelector('.bundle-wrap') || bundle;
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (window.posthog) try { posthog.capture('quiz_apply', { reco: key }); } catch (x) {}
    }

    renderStep();
  }

  /* ───────────────────── RESULTS TIMELINE SIMULATOR ───────────────────── */
  var simu = document.getElementById('simu');
  if (simu) {
    var STEPS = {
      fr: [
        { badge: 'Semaine 1', pct: '+10%', desc: 'Les premiers jours : la cure démarre, vos cils sont hydratés et fortifiés.' },
        { badge: 'Semaine 3', pct: '+45%', desc: 'Le tournant : vos cils paraissent visiblement plus longs et plus denses.' },
        { badge: 'Semaine 6', pct: '+85%', desc: 'Plein effet : longueur et densité maximales, un regard transformé.' }
      ],
      en: [
        { badge: 'Week 1', pct: '+10%', desc: 'The first days: the course begins, your lashes are hydrated and strengthened.' },
        { badge: 'Week 3', pct: '+45%', desc: 'The turning point: your lashes look visibly longer and denser.' },
        { badge: 'Week 6', pct: '+85%', desc: 'Full effect: maximum length and density, a transformed gaze.' }
      ]
    };
    var steps = STEPS[L];
    var range = document.getElementById('simuRange');
    var badge = document.getElementById('simuBadge');
    var pct = document.getElementById('simuPct');
    var desc = document.getElementById('simuDesc');
    var result = document.getElementById('simuResult');
    /* précharge les 3 stades → bascule instantanée, zéro lag */
    if (result) { [result.getAttribute('data-w1'), result.getAttribute('data-w3'), result.getAttribute('data-w6')].forEach(function (s) { if (s) { var im = new Image(); im.src = s; } }); }
    var ticks = simu.querySelectorAll('.simu__ticks span');

    /* localise the static label + tick captions to match the page language */
    var metricLabel = simu.querySelector('.simu__metric-label');
    if (metricLabel) metricLabel.textContent = (L === 'en') ? 'Perceived length' : 'Longueur perçue';
    ticks.forEach(function (t, ti) { t.textContent = steps[ti].badge; });
    var fine = simu.querySelector('.simu__fine');
    if (fine) fine.textContent = (L === 'en')
      ? 'Illustrative projection based on the 3-week self-assessment. Results vary for each person.'
      : "Projection illustrative basée sur l'auto-évaluation à 3 semaines. Les résultats varient selon chacune.";

    function paint(i) {
      var s = steps[i];
      badge.textContent = s.badge;
      pct.textContent = s.pct;
      desc.textContent = s.desc;
      /* 3 stades générés : même œil, cils plus longs semaine après semaine — bascule INSTANTANÉE (préchargé) */
      var srcs = [result.getAttribute('data-w1'), result.getAttribute('data-w3'), result.getAttribute('data-w6')];
      if (srcs[i] && result.getAttribute('src') !== srcs[i]) result.src = srcs[i];
      ticks.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }
    range.addEventListener('input', function () { paint(parseInt(range.value, 10)); });
    ticks.forEach(function (t) {
      t.addEventListener('click', function () {
        var step = parseInt(t.getAttribute('data-step'), 10);
        range.value = step; paint(step);
        if (window.posthog) try { posthog.capture('simu_step', { step: step }); } catch (x) {}
      });
    });
    paint(0);
  }
})();
